import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../components/AppIcon';

const RefundPolicyPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-3">
              <Icon name="ArrowLeft" size={24} className="text-gray-600" />
              <span className="font-poppins font-heading-semibold text-lg text-gray-900">
                Geri Dön
              </span>
            </Link>
            <h1 className="font-poppins font-heading-bold text-2xl text-gray-900">
              İade Politikası
            </h1>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="prose prose-lg max-w-none">
          <div className="mb-8">
            <p className="text-gray-600">
              <strong>Son Güncelleme:</strong> 15 Ocak 2024
            </p>
          </div>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">1. Genel Bilgiler</h2>
            <p className="text-gray-700 leading-relaxed">
              Cafe Otomasyonu olarak müşteri memnuniyeti önceliğimizdir. Bu İade Politikası, dijital hizmetlerimizin iptal ve iade koşullarını açıklar.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">2. Ücretsiz Denemeler</h2>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>QR Menü modülü <strong>daima ücretsiz</strong>dir.</li>
              <li>Yapay Zeka (AI) modülü <strong>15 gün</strong> ücretsiz deneme ile sunulur.</li>
              <li>POS, Online Sipariş ve Kurye modülleri <strong>30 gün</strong> ücretsiz deneme ile sunulur.</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4">
              Deneme süreleri boyunca herhangi bir ücret tahsil edilmez. Deneme sonunda abonelik başlatılmadığı takdirde ücretlendirme yapılmaz.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">3. Dijital Hizmetlerde İade Koşulları</h2>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Ücretli abonelik başlatıldıktan sonra, yürürlükteki mevzuat gereği <strong>dijital hizmetlerde iade</strong> kullanım başlamamışsa ve hizmetten faydalanılmamışsa mümkündür.</li>
              <li>Kullanım başlamış aboneliklerde iade, <strong>kısmi iade</strong> veya <strong>yenileme iptali</strong> şeklinde değerlendirilir.</li>
              <li>Yenileme sonrası <strong>7 gün</strong> içinde başvuru yapılan durumlar öncelikli olarak değerlendirilir.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">4. İptal ve Yenileme</h2>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Abonelik yenilemeleri dönem sonundan önce panel üzerinden iptal edilebilir.</li>
              <li>İptal edilen aboneliklerde, dönem sonuna kadar erişim devam eder.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">5. Başvuru Süreci</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              İade talepleri aşağıdaki kanallar üzerinden iletilebilir:
            </p>
            <div className="bg-gray-50 p-6 rounded-lg">
              <p className="text-gray-700">
                <strong>E-posta:</strong> info@cafeotomasyonu.com<br />
                <strong>Telefon/WhatsApp:</strong> +90 507 588 04 81
              </p>
            </div>
          </section>

          <section>
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">6. Yasal Haklar</h2>
            <p className="text-gray-700 leading-relaxed">
              İşbu İade Politikası, yürürlükteki tüketici mevzuatı kapsamında sahip olduğunuz yasal hakları ortadan kaldırmaz.
            </p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default RefundPolicyPage;


